import type { DedupedResult } from '@deque/jazzband-utils';
import type { UserFlow } from '../../common/api-client';
import type { ExportIssue } from '@deque/axe-devtools-issues-utils/dist/export';
import { type UniversalIssueWithScreenshot } from '@deque/axe-devtools-issues-utils';

export const mapUniversalIssuesToExportIssue = (
  issues: UniversalIssueWithScreenshot[],
  userFlow: UserFlow
): ExportIssue[] =>
  issues.map(issue => ({
    impact: issue.impact,
    tags: issue.tags,
    description: issue.description,
    helpUrl: issue.helpUrl,
    duplicates: issue.duplicates,
    rule: issue.ruleId,
    id: undefined,
    createdAt: issue.createdAt,
    helpText: issue.help,
    selector: issue.selector || [],
    summary: issue.summary || '',
    isBestPractice: false,
    isManual: false,
    isNeedsReview: false,
    source: issue.source || '',
    remediation: { all: [], any: [], none: [] },
    axeVersion: userFlow.axe_core_version || '',
    testUrl: issue.testUrl || '',
    testPageTitle: issue.testPageTitle || '',
    testName: userFlow.name,
    foundBy: userFlow.user_email || '',
    screenshotId: issue.screenshotId
  }));

export const mapDedupedResultsToExportIssue = (
  watcherResults: DedupedResult[],
  userFlow: UserFlow
): ExportIssue[] =>
  watcherResults.flatMap(({ uniques, help, ...issue }) =>
    uniques.flatMap(unique => ({
      ...issue,
      rule: issue.id,
      id: undefined,
      createdAt: new Date(unique.created_at).toISOString(),
      helpText: help,
      selector: unique.target as string[],
      summary: unique.failureSummary,
      isBestPractice: false,
      isManual: false,
      isNeedsReview: false,
      source: unique.html,
      remediation: { all: [], any: [], none: [] },
      axeVersion: userFlow.axe_core_version || '',
      testUrl: unique.url,
      testPageTitle: unique.page_state || '',
      testName: userFlow.name,
      foundBy: userFlow.user_email || ''
    }))
  );
